// Date utility functions using native JavaScript Date API
import { normalizeToFullYear } from './formatting';
import { IDate } from '../types';
import { ITag } from 'types';

export function getStringFromDate(dateInput: IDate | undefined): string {
  const { YYYY } = dateInput ?? {};
  let { DD, MM } = dateInput ?? {};
  if (DD && DD.length === 1) {
    DD = `0${DD}`;
  }
  if (MM && MM.length === 1) {
    MM = `0${MM}`;
  }
  if (YYYY && DD && MM) {
    return `${normalizeToFullYear(YYYY)}-${MM}-${DD}`;
  }
  return '';
}

export function getFormatDateFromObject(dateInput: IDate | undefined): string {
  const { YYYY, DD, MM } = dateInput ?? {};
  if (YYYY && DD && MM) {
    return `${DD}/${MM}/${normalizeToFullYear(YYYY)}`;
  }
  return '';
}

export function getFormatDateFromStoreDate(str: string | undefined): string {
  const date = getDateFromString(str);
  return getFormatDateFromObject(date);
}

export function getDateFromString(str: string | undefined): IDate {
  if (!str) {
    return {
      YYYY: null,
      MM: null,
      DD: null,
    };
  }

  // Check if string matches YYYY-MM-DD format
  const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
  if (dateRegex.test(str)) {
    const dateParts = str.split('-');
    const year = dateParts[0];
    const month = dateParts[1];
    const day = dateParts[2];

    // Validate that the date is actually valid
    const testDate = new Date(`${year}-${month}-${day}`);
    const isValidDate =
      !isNaN(testDate.getTime()) &&
      testDate.getFullYear() === parseInt(year) &&
      testDate.getMonth() === parseInt(month) - 1 &&
      testDate.getDate() === parseInt(day);

    if (isValidDate) {
      return {
        YYYY: year,
        MM: month,
        DD: day,
      };
    }
  }

  return {
    YYYY: null,
    MM: null,
    DD: null,
  };
}

export function getDateFromObject(dateInput: IDate | undefined): Date | null {
  const { YYYY, DD, MM } = dateInput ?? {};
  if (YYYY && DD && MM) {
    return new Date(`${normalizeToFullYear(YYYY)}-${MM}-${DD}`);
  }
  return null;
}

export function isRemovableTag(tag: ITag) {
  return tag.removable === undefined || tag.removable === true;
}

export function constructDateString(year: string, month: string, day: string): string {
  return [year, month, day].join('-');
}

export function constructPaddedDateString(year: string, month: string, day: string): string {
  const paddedMonth = month.length === 1 ? `0${month}` : month;
  const paddedDay = day.length === 1 ? `0${day}` : day;
  return [year, paddedMonth, paddedDay].join('-');
}

export const isSafeUrl = (url: string): boolean => {
  try {
    const { protocol } = new URL(url);
    return protocol === 'https:' || protocol === 'http:';
  } catch {
    return false;
  }
};

export const startTimer = (duration: number, cb: (countDown: string) => void, setNextIntervalReady: () => void) => {
  let timer = duration;
  let minutes;
  let seconds;
  const timerInterval = setInterval(function () {
    minutes = parseInt(`${timer / 60}`, 10);
    seconds = parseInt(`${timer % 60}`, 10);

    minutes = minutes < 10 ? `0${minutes}` : minutes;
    seconds = seconds < 10 ? `0${seconds}` : seconds;

    cb(minutes !== `00` ? `${minutes}:${seconds}` : `${seconds}`);

    if (--timer < 0) {
      clearInterval(timerInterval);
      setNextIntervalReady();
    }
  }, 1000);

  return timerInterval;
};
